/**
 * C4 extracted module: exact playing/visualizer DOM contract from original setPlayingUI().
 *
 * The important CSS trigger remains #beatline-app.is-playing. The original notes and
 * visualizer nodes are not redesigned; this module only toggles the same state that
 * the plugin toggled.
 */
export function setPlayingUI(playing: boolean): void {
  const active = !!playing;

  const app = document.getElementById('beatline-app');
  if (app) app.classList.toggle('is-playing', active);

  const vis = document.getElementById('vis-anim');
  if (vis) (vis as HTMLElement).style.visibility = active ? 'visible' : 'hidden';

  const notes = document.getElementById('notes-anim');
  if (notes) notes.setAttribute('aria-hidden', active ? 'false' : 'true');
}

export function resetPlayingUI(): void {
  setPlayingUI(false);
}
